export default {
  'alert.pgm.form.title.add': {
    ko: 'Add Program Monitor',
    ja: 'Add プログラムモニター',
    en: 'Add Program Monitor',
  },
  'alert.pgm.form.title.edit': {
    ko: 'Edit Program Monitor',
    ja: 'Edit プログラムモニター',
    en: 'Edit Program Monitor',
  },
  'alert.kpi.form.title': {
    ko: 'Edit KPI Threshold',
    ja: 'Edit KPI閾値',
    en: 'Edit KPI Threshold',
  },
  'alert.white.form.title.add': {
    ko: 'Add White List',
    ja: 'Add White List',
    en: 'Add White List',
  },
  'alert.white.form.title.edit': {
    ko: 'Edit White List',
    ja: 'Edit White List',
    en: 'Edit White List',
  },
  'alert.whitelist.sapUserId': {
    ko: 'SAP 사용자 ID.',
    ja: 'SAPユーザーID',
    en: 'SAP User ID.',
  },
  'alert.monitor.notEnd': {
    ko: '미종료 시',
    ja: '未終了時',
    en: 'Not End Case',
  },
  'alert.eos.sap': {
    ko: 'SAP: End of Service',
    ja: 'SAP：テクニカルサポートの終了',
    en: 'SAP: End of Service',
  },
  'alert.user.warningType': {
    ko: '경고 유형',
    ja: '警告タイプ',
    en: 'Warning Type',
  },
  'alert.failback': {
    ko: 'Fail-back 알림 여부',
    ja: 'フェールバックの通知有無',
    en: 'Fail-back',
  },
  'alert.whitelist.rfcFunctionName': {
    ko: 'RFC 모듈명',
    ja: 'RFCモジュール名',
    en: 'RFC Module Name',
  },
  'alert.user.criticalPush': {
    ko: 'Push(심각)',
    ja: 'プッシュ(深刻)',
    en: 'Push(Critical)',
  },
  'alert.eos.dbms': {
    ko: 'DBMS: End of Service',
    ja: 'DBMS：テクニカルサポートの終了',
    en: 'DBMS: End of Service',
  },
  'alert.active': {
    ko: '활성화 여부',
    ja: '有効化の有無',
    en: 'Is active?',
  },
  'alert.display': {
    ko: '화면 표시 여부',
    ja: 'Is display?',
    en: 'Is display?',
  },
  'alert.eos.osdb': {
    ko: 'OS / DBMS',
    ja: 'OS/DBMS',
    en: 'OS / DBMS',
  },
  'alert.warning': {
    ko: '경고',
    ja: '警告',
    en: 'Warning',
  },
  'alert.continuousAlert': {
    ko: '연속 경고 여부',
    ja: '連続警告の有無',
    en: 'Continuous Alert',
  },
  'alert.monitor.elapse': {
    ko: '경과 시',
    ja: '経過時',
    en: 'Elapsed Case',
  },
  'alert.description': {
    ko: '설명',
    ja: '説明',
    en: 'Descriptions',
  },
  'alert.abap.category': {
    ko: 'ABAP Dump Category',
    ja: 'ABAPダンプカテゴリー',
    en: 'ABAP Dump Category',
  },
  'alert.whitelist.taskType': {
    ko: 'Task 유형',
    ja: 'タスクタイプ',
    en: 'Task Type',
  },
  'alert.user.settings': {
    ko: '사용자 알림 설정',
    ja: 'ユーザー通知設定',
    en: 'User Alert settings',
  },
  'alert.whitelist.filterType': {
    ko: 'filter 유형',
    ja: 'フィルタータイプ',
    en: 'Filter Type',
  },
  'alert.eos.name': {
    ko: 'System / Instance / Node',
    ja: 'システム/インスタンス/ノード',
    en: 'System / Instance / Node',
  },
  'alert.eos.vrsn': {
    ko: 'Instance version',
    ja: 'インスタンスバージョン',
    en: 'Instance version',
  },
  'alert.monitor.endTime': {
    ko: '종료 시각',
    ja: '終了時間',
    en: 'Time to Finish',
  },
  'alert.user.programName': {
    ko: 'Program Name',
    ja: 'プログラム名',
    en: 'Program Name',
  },
  'alert.user.criticalEmail': {
    ko: 'E-mail(심각)',
    ja: '電子メール(深刻)',
    en: 'E-mail(Critical)',
  },
  'alert.user.criticalSms': {
    ko: 'SMS(심각)',
    ja: 'SMS(深刻)',
    en: 'SMS(Critical)',
  },
  'alert.decimalFormat': {
    ko: '단위',
    ja: '単位',
    en: 'Decimal Format',
  },
  'alert.monitor.beginEnd': {
    ko: '시작/종료 시',
    ja: '開始/終了時',
    en: 'Begin/End',
  },
  'alert.critical': {
    ko: '심각',
    ja: '深刻',
    en: 'Critical',
  },
  'alert.count': {
    ko: '수집 횟수',
    ja: '収集回数',
    en: 'Collect Count',
  },
  'alert.user.criticalTray': {
    ko: 'Tray(심각)',
    ja: 'トレイ(深刻)',
    en: 'Tray(Critical)',
  },
  'alert.monitor.programName': {
    ko: 'Program Name',
    ja: 'プログラム名',
    en: 'Program Name',
  },
  'alert.monitor.normal': {
    ko: '일반',
    ja: '一般',
    en: 'Normal',
  },
  'alert.abap.errid': {
    ko: 'Error ID',
    ja: 'エラーID',
    en: 'Error ID',
  },
  'alert.whitelist.tcode': {
    ko: 'T-Code',
    ja: 'Tコード',
    en: 'T-Code',
  },
  'alert.user.system': {
    ko: '시스템',
    ja: 'システム',
    en: 'System',
  },
  'alert.monitor.program.name': {
    ko: '프로그램/배치잡',
    en: 'Program/Batch job',
  },
  'alert.monitor.pgm.nm.normal': {
    ko: '프로그램',
    en: 'Program',
  },
  'alert.monitor.pgm.nm.batch': {
    ko: '배치잡',
    en: 'Batch job',
  },
  'alert.monitor.type': {
    ko: '프로그램 유형',
    ja: 'プログラムタイプ',
    en: 'Type of Program',
  },
  'alert.monitor.description': {
    ko: '프로그램 설명',
    ja: 'プログラム説明',
    en: 'Program Description',
  },
  'alert.user.id': {
    ko: '사용자 ID.',
    ja: 'ユーザーID',
    en: 'User ID.',
  },
  'alert.eos.os': {
    ko: 'OS: End of Service',
    ja: 'OS：テクニカルサポートの終了',
    en: 'OS: End of Service',
  },
  'alert.monitor.background': {
    ko: '백그라운드',
    ja: 'バックグラウンド',
    en: 'Background',
  },
  'alert.monitor.elapseTerm': {
    ko: '경과 시간 (초)',
    ja: '経過時間(秒)',
    en: 'Term Elapsed (Sec.)',
  },
  'alert.user.abapId': {
    ko: 'ABAP Dump ID',
    ja: 'ABAPダンプID',
    en: 'ABAP Dump ID',
  },
  'alert.whitelist.report': {
    ko: 'Report',
    ja: 'レポート',
    en: 'Report',
  },
  'alert.monitor.batch.job': {
    ko: '배치잡',
    en: 'Batch job',
  },
  'alert.user.alertType': {
    ko: '알림 유형',
    ja: '通知タイプ',
    en: 'Alert Type',
  },
  // BEGIN::Added.by.KWShin.2024.08.15.
  'alert.chart.title': {
    ko: 'OWLens ALERT Transition',
    ja: 'OWLensアラートの遷移',
    en: 'OWLens ALERT Transition',
  },
  // FINISH::Added.by.KWShin.2024.08.15.
  // BEGIN::Added.by.KWShin.2025.10.31.
  'alert.monitor.label.system': {
    ko: '시스템',
    en: 'System',
  },
  'alert.monitor.label.pgm.nm': {
    ko: '프로그램/배치잡',
    en: 'Program/Batch job',
  },
  'alert.monitor.ph.pgm.nm': {
    ko: "프로그램명 조건 입력 ('%' 허용)",
    en: "Enter Program name... (with '%')",
  },
  'alert.monitor.ph.pgm.nm.one': {
    ko: '프로그램명 입력',
    en: 'Enter Program name',
  },
  'alert.monitor.cancel': {
    ko: '취소 시',
    en: 'Canceled',
  },
  'alert.monitor.jobcount': {
    ko: 'Job count',
    en: 'Job count',
  },
  // FINISH::Added.by.KWShin.2025.10.31.
  // BEGIN::Added.by.KWShin.2026.09.18.
  // 배치잡의 PGM_NM이 JOBNAME::JOBCOUNT::... 에서 JOBNAME::AUTHCKMAN 으로 바뀌면서
  // 등록/수정 화면의 두 번째 칸이 JOBCOUNT가 아니라 AUTHCKMAN이 되었다.
  'alert.monitor.authckman': {
    ko: 'Client (권한검사)',
    ja: 'クライアント(権限チェック)',
    en: 'Client (auth. check)',
    cn: 'Client (auth. check)',
  },
  // FINISH::Added.by.KWShin.2026.09.18.
  // BEGIN::Added.by.KWShin.2026.01.20.
  'alert.ttl.ow.list': {
    ko: 'OWLens ALERT List',
    en: 'OWLens ALERT List',
    cn: 'OWLens ALERT List',
    ja: 'OWLens ALERT List',
  },
  // FINISH::Added.by.KWShin.2026.01.20.
};
